<template>
    <div v-for="(category, index) in childItems" :key="index"
        class="shop_child_items">
        <div class="shop_title">
            {{category.name}}
        </div>

        <div class="shop_items">
            <div class="row">

                <template v-for="(itemChild, index) in category.items" :key="index">

                    <div class="col-12 breakline" v-if="breakline(category.items, index, itemChild.item_type)"></div>

                    <shop-category-item v-if="itemChild.item_type === 'category'" :item="itemChild"/>

                    <shop-trainer-item v-if="itemChild.item_type === 'trainer'" :item="itemChild" :categoryId="category.id" :categoryName="category.name"/>

                    <shop-contract-item v-if="itemChild.item_type === 'contract'" :item="itemChild"/>

                    <shop-service-item v-if="itemChild.item_type === 'service'" :item="itemChild"/>

                    <shop-showmore v-if="itemChild.item_type === 'show_more'" :item="itemChild" :categoryName="category.name"/>

                </template>

            </div>
        </div>

    </div>

    <div class="shop_title">
        {{this.$route.query.categoryName}}
    </div>
    <div class="shop_items">
        <div class="row">
            <template v-for="(item, index) in this.items" :key="index">

                <shop-trainer-item v-if="item.item_type === 'trainer'" :item="item" :categoryId="this.$route.params.categoryId" :categoryName="this.$route.query.categoryName"/>

                <shop-contract-item v-if="item.item_type === 'contract'" :item="item"/>

                <shop-service-item v-if="item.item_type === 'service'" :item="item"/>

            </template>
        </div>

    </div>

</template>

<script>
    import ShopCategoryItem from "./ShopCategoryItem";
    import ShopTrainerItem from "./ShopTrainerItem";
    import ShopContractItem from "./ShopContractItem";
    import ShopServiceItem from "./ShopServiceItem";
    import ShopShowmore from "./ShopShowMore";
    import api from "../../api";

    export default {
        name: "ShopItems",
        components: {ShopShowmore, ShopServiceItem, ShopContractItem, ShopTrainerItem, ShopCategoryItem},
        data() {
            return {
                childItems: [],
                currentChildPage: 1,
                items: [],
                currentPage: 1,
                isChildOver: false,
                isItemsOver: false,
                isFetching: false
            }
        },
        beforeMount() {
            this.$store.commit('SHOW_PRELOADER')
        },
        created() {
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight * 0.7;
                if (bottomOfWindow && !this.isFetching && !this.isChildOver) {
                    this.loadChildItems();
                }
                if (bottomOfWindow && !this.isFetching && this.isChildOver && !this.isItemsOver) {
                    this.loadItems();
                }
            }
            this.loadChildItems();
        },
        methods: {
            breakline(items, index, item_type) {
                return items[index - 1] !== undefined && items[index - 1].item_type !== item_type;
            },
            async loadChildItems() {
                this.isFetching = true
                let categoryId = this.$route.params.categoryId
                let items = (await api.shop.getCatalogChild({
                    params: {
                        category_id: categoryId,
                        page: this.currentChildPage
                    }
                })).data.items;

                if (items.length === 0){
                    this.isChildOver = true
                    await this.loadItems();
                }else{
                    this.childItems = this.childItems.concat(items)
                    this.currentChildPage++
                }
                this.$store.commit('HIDE_PRELOADER')
                this.isFetching = false
            },
            async loadItems() {
                if (this.$route.params.categoryId === undefined){
                    this.isItemsOver = true
                    return false
                }

                this.isFetching = true
                let categoryId = this.$route.params.categoryId
                let items = (await api.shop.getCatalogItems({
                    params: {
                        category_id: categoryId,
                        page: this.currentPage
                    }
                })).data.items;

                if (items.length === 0){
                    this.isItemsOver = true
                }else{
                    this.items = this.items.concat(items)
                    this.currentPage++
                }
                this.isFetching = false
            },
        },
    }
</script>